<template>
  <v-card flat>
    <v-form ref="findPersonForm" v-model="valid" lazy-validation>
      <v-autocomplete
       data-cy="person-autocomplete"
        v-model="person"
        :loading="isLoading"
        :search-input.sync="search"
        item-value="id"
        item-text="displayName"
        :items="people"
        hide-no-data
        no-filter
        outlined
        clearable
        return-object
        :clear-icon="person ? '$sl-close' : ''"
        append-icon=""
        :label="label"
        click:clear="clearField"
        @change="emitPerson"
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title :data-cy="data.item.firstName"
                >{{ data.item.firstName }} {{ data.item.lastName }} ({{ data.item.personalNumber }})</v-list-item-title
              >
              <v-list-item-subtitle
                >{{ data.item.address1 }}, {{ data.item.zip }} {{ data.item.city }}</v-list-item-subtitle
              >
              <v-list-item-subtitle>{{ data.item.mobilephone }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ data.item.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>

      <v-expansion-panels v-if="person && Object.keys(person).length > 0" class="mt-n5 mb-6">
        <v-expansion-panel>
          <v-expansion-panel-header class="subtitle-1 semi-bold text-uppercase" expand-icon="$sl-arrow-down"
            >INFORMATION OM {{ person | fullName }}</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-row class="mt-n4">
              <v-col cols="12" md="6">
                <p class="overline">MOBILTELEFON</p>
                <p class="mt-n3" v-if="person && person.mobilephone">
                  {{ person.mobilephone }}
                </p>

                <p class="overline mt-n2">E-POSTADRESS</p>
                <p class="mt-n3 pb-0 mb-n4" v-if="person && person.email">
                  <a :href="`mailto:${person.email}`"> {{ person.email }}</a>
                </p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="overline">Adress</div>
                <p>{{ person.address1 }}</p>
                <p v-if="person.address2">{{ person.address2 }}</p>
                <p class="mt-n8">{{ person.zip }} {{ person.city }}</p>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
  </v-card>
</template>

<script>
import debounce from 'lodash/debounce'
import API from '@/services/api.js'

// @group Common
// PersonDisplay component
export default {
  name: 'PersonFind',
  props: {
    label: {
      type: String,
      default: 'Person'
    },
    // The v-model value
    value: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return {}
      }
    }
  },

  data: () => ({
    isLoading: false,
    valid: true,
    search: null,
    person: {},
    showPersonInfo: {},
    people: []
  }),

  watch: {
    search(newVal) {
      this.listPersons(newVal)
    },
    value: {
      handler: function () {
        this.person = JSON.parse(JSON.stringify(this.value))
      },
      deep: true
    }
  },

  created() {
    this.person = JSON.parse(JSON.stringify(this.value))
  },

  methods: {
    emitPerson(val) {
      this.showPersonInfo = val
      this.$emit('input', val ? val : null)
    },

    listPersons: debounce(function () {
      this.doListPersons(this.search)
    }, 500),

    doListPersons(q) {
      let personIsSearched = this.person && this.person.displayName ? this.person.displayName : {}
      if (this.isLoading || q === personIsSearched || q === null || q === '') return
      this.isLoading = true
      API.listPersons({
        startAt: 0,
        pageSize: 200,
        sortBy: 'lastName',
        sortDesc: false,
        search: q
      })
        .then(res => {
          this.people = res.data.rows

          this.people.forEach(o => {
            o.displayName = `${o.firstName} ${o.lastName} (${o.personalNumber})`
          })
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    clearField() {
      console.log('clear')
      /* this.$refs.findPersonForm.reset()
      this.person = {} */
    }
  }
}
</script>

<style>
</style>